<div class="d-flex flex-column h-100 w-100 position-relative">
    @if (showCloseButton) {
        <div
            class="close d-flex align-items-center justify-content-center position-absolute top-0 end-0 rounded-circle bg-light lh-1 mt-3 me-3 shadow"
            (click)="dialogRef?.close()"
            matTooltipPosition="after">
            <i class="fa fa-times fs-5"></i>
        </div>
    }
    <swiper-container
        #swiperEl
        class="d-block flex-grow-1 h-100 w-100"
        navigation="true"
        zoom="true"
        loop="true"
        maxRatio="10"
        mousewheel="true">
        @if (data.singlePdf) {
            <swiper-slide #slideEl class="h-100 overflow-hidden position-relative">
                <div
                    #zoomContainerEl
                    class="swiper-zoom-container d-flex align-items-center justify-content-center h-100 position-relative p-1 p-sm-3"
                    data-swiper-zoom="8">
                    @if (fileNotFound) {
                        <div class="d-flex align-items-center justify-content-center h-100 w-100">
                            <div class="alert alert-warning mb-0" role="alert">Bestand kan niet getoond worden.</div>
                        </div>
                    } @else {
                        <canvas class="d-block mw-100 mh-100" #pdfCanvas></canvas>
                    }
                </div>
                <!-- Overlays a sharp render of only the currently visible crop while zoomed; positioned/sized
                     imperatively in ImageModalComponent to match the live Swiper pan/zoom, not through bindings. -->
                <canvas #pdfDetailCanvas class="position-absolute pe-none" style="display: none"></canvas>
            </swiper-slide>
        } @else {
            @for (image of images; track image) {
                <swiper-slide class="h-100 overflow-hidden">
                    <div
                        class="swiper-zoom-container d-flex align-items-center justify-content-center h-100 position-relative p-1 p-sm-3">
                        <img class="d-block mw-100 mh-100" [src]="image.image" alt="image" />
                    </div>
                </swiper-slide>
            }
        }
    </swiper-container>
    @if (data?.singlePdf && numberOfPages.length > 1) {
        <div class="d-flex flex-nowrap flex-shrink-0 gap-2 overflow-auto overflow-x-auto p-3 bg-white mw-100">
            @for (page of numberOfPages; track page) {
                <button
                    class="page-btn d-flex align-items-center justify-content-center rounded-circle border fw-semibold lh-1 p-0"
                    [class.bg-primary]="page === currentPage"
                    [class.border-primary]="page === currentPage"
                    [class.text-white]="page === currentPage"
                    [class.bg-light]="page !== currentPage"
                    [disabled]="loadingPdf"
                    (click)="loadPage(page)"
                    type="button">
                    {{ page }}
                </button>
            }
        </div>
    }
</div>
